<template>
  <span class="extras-mg-fila">
    <i
      v-if="motivo"
      v-tooltip="motivo"
      class="extras-mg-fila__aviso iconoir-warning-triangle"
      :aria-label="motivo"
    ></i>
    <GridViewRowExpandButtonWithCommentCount
      :row="row"
      :table="table"
      :workspace-id="workspaceId"
      @edit-modal="$emit('edit-modal')"
    />
  </span>
</template>

<script>
/**
 * El botón de abrir la fila en la cuadrícula, con un aviso al lado cuando la
 * dependencia de fechas marcó la fila como inválida (la dejaste empezando antes
 * de que acabe su predecesora, o terminando antes de empezar).
 *
 * El core 2.3.3 guarda esa marca pero no la pinta. Este botón es el único hueco
 * que deja en cada fila para un plugin (getRowExpandButtonComponent, el mismo
 * que premium usa para el conteo de comentarios), así que se envuelve el de
 * premium para no perder ese conteo. Las filas marcadas las trae VigiaDeFechas.
 */
import GridViewRowExpandButtonWithCommentCount from '@baserow_premium/components/row_comments/GridViewRowExpandButtonWithCommentCount'
import { esInvalida, reglaEnUso } from '@extras_mg/utils/filasInvalidas'

export default {
  name: 'BotonDeFila',
  components: { GridViewRowExpandButtonWithCommentCount },
  props: {
    row: { type: Object, required: false, default: null },
    table: { type: Object, required: false, default: null },
    workspaceId: { type: [Number, String], required: false, default: null },
  },
  emits: ['edit-modal'],
  computed: {
    motivo() {
      const regla = this.table && reglaEnUso(this.$store, this.table.id)
      if (!regla || !this.row || !esInvalida(this.table.id, this.row.id)) {
        return ''
      }
      // Fechas sin hora: 'AAAA-MM-DD', se comparan como texto.
      const inicio = this.row[`field_${regla.campo_inicio_id}`]
      const fin = this.row[`field_${regla.campo_fin_id}`]
      return inicio && fin && fin < inicio
        ? 'Termina antes de empezar'
        : 'Empieza antes de que termine su predecesora'
    },
  },
}
</script>

<style lang="scss">
/* Sin colores fijos: build-theme.py convierte los hex del CSS compilado. El
   naranja es el de la piel (branding/piel-monday.css), definido en :root, así
   que vale con cualquier piel y tema. */

/* Sin caja propia: el aviso y el botón siguen siendo hijos flex de
   .grid-view__row-info, y el botón queda a la derecha de la casilla. */
.extras-mg-fila {
  display: contents;
}

.extras-mg-fila__aviso {
  color: var(--mg-naranja);
  flex-shrink: 0;
  font-size: 14px;
  margin-right: 4px;
}
</style>
